import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategorieComponent } from './categorie.component';
import { CategorieRoutingModule } from './categorie-routing.module';
import { FormsModule } from '@angular/forms';
import { CategorieComboComponent } from './categorie-combo/categorie-combo.component';
import { CategorieListComponent } from './categorie-list/categorie-list.component';
import { CategorieCreateComponent } from './categorie-create/categorie-create.component';
import { CategorieEditComponent } from './categorie-edit/categorie-edit.component';
import { CategorieByMarchioComponent } from './categorie-by-marchio/categorie-by-marchio.component';
import { CategorieDetailsComponent } from './categorie-details/categorie-details.component';
import { CategoriaFormComponent } from './categoria-form/categoria-form.component';
import { MyCustomMaterialModule } from 'san-common';


@NgModule({
  imports: [
      CommonModule,
      CategorieRoutingModule,
      MyCustomMaterialModule,
      FormsModule,

  ],
  declarations: [
    CategorieComponent,
    CategorieComboComponent,
  CategorieListComponent,
CategorieCreateComponent,
CategorieEditComponent,
CategorieByMarchioComponent,
CategorieDetailsComponent,
CategoriaFormComponent
],
    exports: [
      CategorieComponent,
      CategorieComboComponent,
  CategorieListComponent,
  CategorieCreateComponent,CategorieEditComponent,
  CategorieByMarchioComponent,
  CategorieDetailsComponent,
  CategoriaFormComponent
    ],
  providers: []
})
export class CategorieModule { }
